import { IGenericConsumerViewRollups } from "./IGPSData";
import { IBrand } from "./IBrand";
import { IBrandCategory } from "./IBrandCategory";
import { RenderType } from "../Enums/RenderType";

export interface IRetailMatchJobResult {
  chartData: IRetailMatchChartData;
  job: IRetailMatchJob;
  status: string;
}

interface IStoreTradeAreaBlockGroup {
  id: string;
  tradeAreaBlockGroups: IRetailMatchTradeAreaBlockGroup[];
}

interface IBrandConsumerViewRollup {
  id: string;
  consumerViewRollups: IGenericConsumerViewRollups;
}

export interface IRetailMatchTradeAreaBlockGroup {
  id: string;
  val: number;
}
export interface IRetailMatchChartData {
  brandProfiles: IProfileGroup[];
  overview: IRetailMatchOverview[];
  siteProfile: IProfileRecord[];
  storeScores: IStoreScoreRecord[];
  brandConsumerViewRollups: IBrandConsumerViewRollup[];
  nationalConsumerViewRollups: IGenericConsumerViewRollups;
  siteConsumerViewRollups: IGenericConsumerViewRollups;
  siteTradeAreaBlockGroups: IRetailMatchTradeAreaBlockGroup[];
  storeTradeAreaBlockGroups: IStoreTradeAreaBlockGroup[];
  benchmarkRecords: IStoreScoreRecord[];
}

export interface IRetailMatchJob {
  brands: IBrand[];
  cacheUrl: any;
  categories: IBrandCategory[];
  cid: number;
  createdDateTime: string;
  datasetId: string;
  endDate: string;
  geoType: string;
  geoValues: string[];
  id: number;
  jobEndEpoch: number;
  jobId: string;
  jobStartEpoch: number;
  jobType: string;
  modifiedDateTime: string;
  projectId: string;
  sgFilter: true;
  siteLatitude: number;
  siteLongitude: number;
  startDate: string;
  status: string;
  tableId: string;
  title: string;
  totalBytesProcessed: number;
  tradeAreaLimit: boolean;
  siteDetails: string;
  uid: number;
  images: IRetailMatchJobImage[];
  addressOverride: string;
  cityOverride: string;
  stateOverride: string;
  zipcodeOverride: string;
}

export interface IRetailMatchJobImage {
  id: number;
  isActive: boolean;
  url: string;
}

export interface IRetailMatchUpdateBrandLogoResponse {
  jobId: string;
  brandId: string;
  logoUrl: string;
}

export interface IRetailMatchOverview {
  jobId: string;
  brandId: string;
  brandName: string;
  sampleCount: number;
  brandCount: number;
  samplePercent: number;
  avgSampleVolumeIndex: number;
  coreCustomerCountIndex: number;
  coreCustomerPerHouseholdIndex: number;
  coreCustomerCorrelationIndex: number;
  averageIndex: number;
  rank: number;
}

interface IBlockGroupTARecord {
  jobId: string;
  storeId: string;
  brandId: string;
  blockGroupId: string;
  isTradeArea: boolean;
  normalizedVisitPercent: number;
  coreCustomerCount: number;
  coreCustomerPercent: number;
}

export interface IProfileRecord {
  seg: string;
  pct: number;
  core: "P" | "S" | "N" | "T";
  bCore?: "P" | "S" | "N" | "T";
  index: number;
  brandId?: string;
}

export interface IProfileGroup {
  id: string;
  profile: IProfileRecord[];
}

export interface IStoreTradeAreaBlockGroups {
  id: string;
  tradeAreaBlockGroups: IRetailMatchTradeAreaBlockGroup[];
}

export interface IStoreScoreRecord {
  sid: string /*Store Id*/;
  bid: string /*Brand Id*/;
  bnm: string /*Brand Name*/;
  addr: string /*Address*/;
  city: string /*City*/;
  st: string /*State*/;
  zip: string /*Zip*/;
  buds: number /*BUDS*/;
  hhCnt: number /*Household Count*/;
  hhCntIdx: number /*Household Count Index*/;
  ccCnt: number /*Core Customer Count*/;
  ccCntIdx: number /*Core Customer Count Index*/;
  ccPerHHCnt: number /*Core Customer Per HH Count*/;
  ccPerHHCntIdx: number /*Core Customer Per HH Count Index*/;
  vCnt: number /*Volume Count*/;
  vCntIdx: number /*Volume Count Index*/;
  ccCorr: number /*Core Customer Correlation*/;
  ccCorrIdx: number /*Core Customer Correlation Index*/;
  lat: number;
  lon: number;
  fullAddr?: string /* Added later in Locations Analyzed */;
}

export interface IRetailMatchChartSection {
  brand: IBrand;
  chartData: IRetailMatchChartData;
  locationAddress?: string;
  renderType: RenderType;
}
